// src/components/propertyPanel/ComponentProperties/ProductDetailProperties.js
import React from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';
import { usePropertyPanel } from '../PropertyPanelContext';
import { PaddingControl, SkinSelector } from '../CommonProperties';

const ProductDetailProperties = () => {
  // 선택된 컴포넌트 가져오기
  const selectedComponent = useSelector(selectSelectedComponent);
  
  // 컨텍스트에서 필요한 함수 가져오기
  const { handleComponentPropsChange } = usePropertyPanel();
  
  // 컴포넌트 속성 변경 핸들러
  const handlePropertyChange = (property, value) => {
    if (!selectedComponent) return;
    handleComponentPropsChange(property, value);
  };

  return (
    <>
      {/* 스킨 선택 */}
      <SkinSelector
        selectedComponent={selectedComponent}
        onSkinChange={(skinId) => handlePropertyChange('skin', skinId)}
      />
      
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 12H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 17H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          탭 표시 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>설명(Description) 탭</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-description-tab"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showDescriptionTab !== false}
              onChange={(e) => handlePropertyChange('showDescriptionTab', e.target.checked)}
            />
            <label htmlFor="toggle-description-tab" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>리뷰(Reviews) 탭</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-reviews-tab"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showReviewsTab !== false}
              onChange={(e) => handlePropertyChange('showReviewsTab', e.target.checked)}
            />
            <label htmlFor="toggle-reviews-tab" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        {/* <div className="property-row">
          <label style={{ minWidth: '30%' }}>상세 스펙(Specification) 탭</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-specification-tab"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showSpecificationTab !== false}
              onChange={(e) => handlePropertyChange('showSpecificationTab', e.target.checked)}
            />
            <label htmlFor="toggle-specification-tab" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div> */}
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>재고 정보 표시</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-stock-display"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showStock === true}
              onChange={(e) => handlePropertyChange('showStock', e.target.checked)}
            />
            <label htmlFor="toggle-stock-display" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
      </div>

      {/* 적립금 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
          </svg>
          적립금 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>적립금 표시</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-show-reward-points-detail"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showRewardPoints === true}
              onChange={(e) => handlePropertyChange('showRewardPoints', e.target.checked)}
            />
            <label htmlFor="toggle-show-reward-points-detail" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        {selectedComponent.componentProps?.showRewardPoints && (
          <>
            <div className="property-row">
              <label style={{ minWidth: '30%' }}>적립 기준</label>
              <select 
                value={selectedComponent.componentProps?.rewardPointBase || 'pv'}
                onChange={(e) => handlePropertyChange('rewardPointBase', e.target.value)}
                style={{ width: '100%' }}
              >
                <option value="pv">PV 기준</option>
                <option value="price">판매가 기준</option>
              </select>
            </div>
            
            <div className="property-row">
              <label style={{ minWidth: '30%' }}>적립 비율 (%)</label>
              <input 
                type="number" 
                min="0"
                max="100"
                step="0.1"
                value={selectedComponent.componentProps?.rewardPointPercentage || 1}
                onChange={(e) => handlePropertyChange('rewardPointPercentage', parseFloat(e.target.value) || 1)}
              />
            </div>
            
            <div className="property-row">
              <label style={{ minWidth: '30%' }}>적립금 라벨</label>
              <input 
                type="text" 
                value={selectedComponent.componentProps?.rewardPointLabel || '적립금'}
                onChange={(e) => handlePropertyChange('rewardPointLabel', e.target.value)}
              />
            </div>
            
            <div className="property-row">
              <label style={{ minWidth: '30%' }}>표시 형식</label>
              <select 
                value={selectedComponent.componentProps?.rewardPointFormat || 'amount'}
                onChange={(e) => handlePropertyChange('rewardPointFormat', e.target.value)}
                style={{ width: '100%' }}
              >
                <option value="amount">금액만 표시</option>
                <option value="percentage">퍼센트만 표시</option>
                <option value="both">금액과 퍼센트 모두 표시</option>
              </select>
            </div>
          </>
        )}
      </div>

      {/* 표시 옵션 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          표시 옵션
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>관련 상품 표시</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-related-products"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showRelatedProducts !== false}
              onChange={(e) => handlePropertyChange('showRelatedProducts', e.target.checked)}
            />
            <label htmlFor="toggle-related-products" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>수량 선택기</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-quantity-selector"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showQuantitySelector !== false}
              onChange={(e) => handlePropertyChange('showQuantitySelector', e.target.checked)}
            />
            <label htmlFor="toggle-quantity-selector" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>장바구니 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-add-to-cart"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showAddToCart !== false}
              onChange={(e) => handlePropertyChange('showAddToCart', e.target.checked)}
            />
            <label htmlFor="toggle-add-to-cart" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>바로구매 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-buy-now"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showBuyNow !== false}
              onChange={(e) => handlePropertyChange('showBuyNow', e.target.checked)}
            />
            <label htmlFor="toggle-buy-now" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
      </div>

      {/* 스타일 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          스타일 설정
        </div>
        
        <div className="property-row">
          <label>가격 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.priceColor || '#ff6b6b'}
            onChange={(e) => handlePropertyChange('priceColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>장바구니 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.addToCartButtonColor || '#007bff'}
            onChange={(e) => handlePropertyChange('addToCartButtonColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>바로구매 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.buyNowButtonColor || '#28a745'}
            onChange={(e) => handlePropertyChange('buyNowButtonColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>재고 텍스트 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.stockTextColor || '#28a745'}
            onChange={(e) => handlePropertyChange('stockTextColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
      </div>
    </>
  );
};

export default ProductDetailProperties;